import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import { GetUserEmailDocument } from '@xing-com/crate-jobs-graphql';

export type UserEmail = {
  isLoading: boolean;
  email?: string;
  error?: ApolloError;
};

export const useUserEmail = (): UserEmail => {
  const { loading, error, data } = useQuery(GetUserEmailDocument);
  const email = data?.viewer?.accountSettings?.email?.active ?? undefined;

  return { isLoading: loading, email, error };
};
